import styled from 'styled-components';

const AbstractText = styled.div`
  text-align: ${(props) => props.textAlign};
  color: ${(props) => props.color || '#232d3a'};
`;

export default AbstractText;
